let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <deliveryOrder>
        <deliveryOrderCode>销售单号(ERP分配), string (50), 必填</deliveryOrderCode>
        <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
        <ownerCode>货主编码, string (50), 必填</ownerCode>
        <createTime>销售单创建时间, string (19), YYYY-MM-DD HH:MM:SS</createTime>
        <orderType>销售单类型, string (50),  例如: XSDD=销售订单、DBCK=调拨出库、THCK=退货出库、QTCK=其他出库(只传英文编码), 必填</orderType>
        <remark>备注, string (500)</remark>
        <logisticsCode>物流公司编码, string (50), SF=顺丰、EMS=标准快递、EYB=经济快件、ZJS=宅急送、YTO=圆通、ZTO=中通、HTKY=百世汇通、UC=优速、STO=申通、TTKDEX=天天快递、QFKD=全峰、FAST=快捷、POSTB=邮政小包、GTO=国通、YUNDA=韵达、JD=京东配送、DD=当当宅配、AMAZON=亚马逊物流、OTHER=其他(只传英文编码), 条件必填, 条件为B2C订单</logisticsCode>
        <expressCode>运单号, string (50)</expressCode>
        <shopNick>店铺名称, string (50), 条件必填, 条件为B2C订单</shopNick>
        <carryRoute>发运路线, string (50)</carryRoute>
        <carryCompany>承运商, string (50)</carryCompany>
        <sourcePlatformCode>订单来源平台编码, string (50), TB= 淘宝、TM=天猫、JD=京东、DD=当当、PP=拍拍、YX=易讯、EBAY=ebay、QQ=QQ网购、AMAZON=亚马逊、SN=苏宁、GM=国美、WPH=唯品会、JM=聚美、LF=乐蜂、MGJ=蘑菇街、JS=聚尚、PX=拍鞋、YT=银泰、YHD=1号店、VANCL=凡客、YL=邮乐、YG=优购、1688=阿里巴巴、POS=POS门店、MIA=蜜芽、GW=商家官网、CT=村淘、OTHER=其他(只传英文编码), 条件必填, 条件为B2C订单</sourcePlatformCode>
        <customerCode>客户编码, string (50), 标准发货通知单、VMI发货通知单取客户编码, 标准退货通知单取供应商编码, 分销调拨发货通知单取调出方编码、其他出库取公司编码</customerCode>
        <customer>客户名称, string (50), 标准发货通知单、VMI发货通知单取客户名称, 标准退货通知单取供应商名称, 分销调拨发货通知单取调出方名称、其他出库取公司名称</customer>
        <entryOrderCode>销售单对应的申请单号, string (50)</entryOrderCode>
        <placedAt>下单时间, string (19), YYYY-MM-DD HH:MM:SS</placedAt>
        <payTime>付款时间, string (19), YYYY-MM-DD HH:MM:SS</payTime>
        <datePlanned>预计到达时间, string (19), YYYY-MM-DD HH:MM:SS </datePlanned>
        <documentMaker>制单人, string (50)</documentMaker>
        <totalAmount>订单总金额, string (50)</totalAmount>
        <itemAmount>商品总金额, string (50)</itemAmount>
        <discountAmount>订单折扣金额, string (50)</discountAmount>
        <freight>快递费用, string (50)</freight>
        <arAmount>应收金额, string (50)</arAmount>
        <gotAmount>已收金额, string (50)</gotAmount>
        <serviceFee>COD服务费, string (50)</serviceFee>
        <sourceOrderCode>来源单号, string (50)</sourceOrderCode>
        <buyerMessage>买家留言, string (500)</buyerMessage>
        <sellerMessage>卖家留言, string (500)</sellerMessage>
        <senderInfo>
            <name>姓名, string (50),  条件必填, 条件为B2C订单</name>
            <mobile>移动电话, string (50), 条件必填, 条件为B2C订单</mobile>
            <province>省份, string (50), 条件必填, 条件为B2C订单</province>
            <city>城市, string (50), 条件必填, 条件为B2C订单</city>
            <area>区域, string (50)</area>
            <town>村镇, string (50)</town>
            <detailAddress>详细地址, string (200), 条件必填, 条件为B2C订单</detailAddress>
            <company>公司名称, string (200)</company>
            <zipCode>邮编, string (50)</zipCode>
        </senderInfo>
        <receiverInfo>
            <name>姓名, string (50), 必填</name>
            <tel>固定电话, string (50)</tel>
            <mobile>移动电话, string (50), 条件必填, 条件为B2C订单</mobile>
            <province>省份, string (50), 条件必填, 条件为B2C订单</province>
            <city>城市, string (50), 条件必填, 条件为B2C订单</city>
            <area>区域, string (50)</area>
            <town>村镇, string (50)</town>
            <detailAddress>详细地址, string (200), 必填</detailAddress>
            <company>公司名称, string (200)</company>
            <zipCode>邮编, string (50)</zipCode>            
            <countryCode>国家二字码, string (50)</countryCode>  
            <email>电子邮箱, string (50)</email>  
        </receiverInfo>
        <invoiceFlag>发票标记,  string (5), N=不需要发票, Y=需要发票, 默认为N</invoiceFlag>
        <invoices>
            <invoice>
                <type>发票类型, string (50)</type>
                <header>发票抬头, string (100)</header>
                <amount>发票金额, float</amount>
                <content>发票内容, string (255)</content>
                <taxNumber>税号, string (50)</taxNumber>
                <detail>
                    <items>
                        <item>
                            <itemName>商品名称, string (50)</itemName>
                            <unit>商品单位, string (50)</unit>
                            <price>商品单价, float</price>
                            <quantity>数量, float</quantity>
                            <amount>金额, float</amount>
                        </item>
                    </items>
                </detail>
            </invoice>
        </invoices>
        <customProps>
            <payMode>运费付款方式, string (20)</payMode>
            <carryMode>货运模式, string (30)</carryMode>
            <isInsured>是否投保, string (50)</isInsured>
            <insuranceMoney>投保金额, float (15,2)</insuranceMoney>
            <consignee>提货人, string (20)</consignee>
        </customProps>
        <userDefined1>自定义1, string (50)</userDefined1>
        <userDefined2>自定义2, string (50)</userDefined2>
        <userDefined3>自定义3, string (50)</userDefined3>
        <userDefined4>自定义4, string (50)</userDefined4>
        <customJson>自定义json</customJson>
    </deliveryOrder>
    <orderLines>
        <orderLine>
            <lineNo>行号, int</lineNo>    
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemId>仓储系统商品编码, string (50)</itemId>
            <planQty>应发商品数量, float, 必填</planQty>
            <actualPrice>价格 string (50)</actualPrice>
            <inventoryType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP. 必填</inventoryType>
            <virtualWarehouse>虚拟仓库, string (50), 条件必填, 条件为使用虚拟仓库</virtualWarehouse>
            <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
            <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
            <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
            <batchCode>批次号, string (50)</batchCode>
            <userDefined1>自定义批次1, string (50)</userDefined1>
            <userDefined2>自定义批次2, string (50)</userDefined2>
            <userDefined3>自定义批次3, string (50)</userDefined3>
            <userDefined4>自定义批次4, string (50)</userDefined4>
            <customJson>自定义json</customJson>
            <customField1>自定义字段1, string (50)</customField1>
            <customField2>自定义字段2, string (50)</customField2>
            <customField3>自定义字段3, string (50)</customField3>
            <customField4>自定义字段4, string (50)</customField4>
            <customField5>自定义字段5, string (50)</customField5>
            <customField6>自定义字段6, string (50)</customField6>
            <customField7>自定义字段7, string (50)</customField7>
            <customField8>自定义字段8, string (50)</customField8>
        </orderLine>
    </orderLines>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
    <deliveryOrderId>销售订单仓储系统编码, string (50)</deliveryOrderId>
    <createTime>订单创建时间, string (19), YYYY-MM-DD HH:MM:SS</createTime>
</response>
`

export default {
    xmlRequest,
    xmlResponse
}



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.saleorder.create.js